export function fmtDate(v, withTime = false) {
  if (!v) return "—";
  try {
    const d = new Date(v);
    if (isNaN(d)) return String(v).slice(0, 10);
    if (!withTime && /^\d{4}-\d{2}-\d{2}$/.test(String(v))) {
      return new Date(`${v}T00:00:00Z`).toLocaleDateString("en-IN", { timeZone: "UTC", day: "2-digit", month: "short", year: "numeric" });
    }
    const opts = withTime
      ? { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }
      : { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric" };
    return d.toLocaleDateString("en-IN", opts);
  } catch {
    return String(v);
  }
}

export function fmtCurrency(n) {
  if (n == null || n === "") return "—";
  const num = Number(n);
  if (isNaN(num)) return String(n);
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(num);
}

export function fmtNumber(n) {
  if (n == null) return "0";
  return new Intl.NumberFormat("en-IN").format(n);
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}

export function normalizePhone(v) {
  if (!v) return "";
  let d = String(v).replace(/\D/g, "");
  if (d.length === 10) d = "91" + d;
  return d;
}

export function whatsappLink(phone, message) {
  const num = normalizePhone(phone);
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${num}${text}`;
}

export function timeAgo(v) {
  if (!v) return "—";
  const d = new Date(v);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
